import { Box, Typography } from "@mui/material";
import { RTL } from "../cache/CacheRtl";
import { v2 } from "../componenets/nutrition/v2/ui/v2Tokens";
import MenuTemplatesListV2 from "../componenets/nutrition/v2/MenuTemplatesListV2";

/**
 * The company's menu templates, on their own page.
 *
 * They used to be a tab of ספריית תזונה, which put two unrelated jobs behind one heading: a
 * template is a whole menu you build and open, and a saved meal is one meal you reuse. Splitting
 * them means the nav can point at each directly, and a template gets a page big enough to be
 * created and edited on rather than a card that could only list what already existed.
 *
 * `/app/global-templates` — the V1 page these came from — redirects here.
 */
const MenuTemplatesPage = () => (
  <RTL>
    <Box sx={{ display: "flex", flexDirection: "column", gap: "18px" }}>
      <Box sx={{ display: "flex", alignItems: "center", gap: 1.25, flexWrap: "wrap" }}>
        <Typography
          sx={{
            fontSize: { xs: "22px", md: "26px" },
            fontWeight: 800,
            color: v2.ink,
            lineHeight: 1.2,
            letterSpacing: "-0.3px",
          }}
        >
          תבניות תפריטים
        </Typography>
        <Box sx={{ fontSize: "12.5px", color: v2.ink3 }}>משותפות לכל המאמנים בחברה</Box>
      </Box>

      <MenuTemplatesListV2 />
    </Box>
  </RTL>
);

export default MenuTemplatesPage;
